/*
 *
 * AddReference actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';

export const addRefenceAction = (reference: string) =>
  action(ActionTypes.ADD_REFERENCE_REQUEST, { reference });
export const addRefenceSuccessAction = () =>
  action(ActionTypes.ADD_REFERENCE_SUCCESS);
export const addRefenceFailureAction = (error: string) =>
  action(ActionTypes.ADD_REFERENCE_FAILURE, { error });
